import { createContext } from 'react'

const petContext = createContext()

export default petContext
